import React from "react";
import { Navigate, useLocation } from "react-router-dom";

/** Preserves query string when moving from legacy client-portal paths to nested routes. */
export default function ClientPortalLegacyRedirect({ to }) {
  const { search } = useLocation();
  return <Navigate to={`${to}${search}`} replace />;
}
